import { Component, OnInit, ViewChild, } from "@angular/core";
import { VernostServiceService } from "../../../services/vernost-service.service";
import { MatInput } from "@angular/material";
import { DatePipe } from "@angular/common";
import { Router } from "@angular/router";
import { saveAs } from "file-saver";
import  serverConfigInfo from "../../../../../Server/config.json"

@Component({
  selector: "app-cancel-booking",
  templateUrl: "./cancel-booking.component.html",
  providers: [DatePipe]
})
export class CancelBookingComponent implements OnInit {
  @ViewChild("input", { read: MatInput }) input: MatInput;
  @ViewChild("input2", { read: MatInput }) input2: MatInput;
  @ViewChild("input3", { read: MatInput }) input3: MatInput;
  @ViewChild("input4", { read: MatInput }) input4: MatInput;

  screentitle: string = "Cancel Booking";
  invaliddateCB = false;
  showsingle1 = true;
  showMultiple1 = true;
  final;
  downd = true;
  searchlist: boolean = true;
  mydate = new Date();
  journeydate = false;
  search_details_CB;
  isFname = false;
  isLname = false;
  tomorrow1;
  isOrd = false;
  isPnr = false;
  disablebtnCB = true;
  bookingdate = false;
  tomorrow;
  booking_ref: any = "";
  isAccrual: boolean = true;
  p: number = 1;
  search_result_list: any = [];
  order_Id_list: any = [];
  search_detail_list: any = [];
  existingbooking: boolean = true;
  bookinglist: boolean = false;
  booking_details: any = "";
  cancelBooking_aff_partner:any = [];
  booking_details_info: any = [];
  // segment_details: any = "";
  pax_detail: any = "";

  segment_details1: any = [];
  segment_details2: any = [];
  selectedOutboundPaxArrayCB = [];
  selectedInboundPaxArrayCB = [];
  loader: any = false;
  isloader: any = false;
  uidCB;
  cancelbtnCB;
  BOOKING_STATUS;
  cancelHistory: any = [];
  isCancelOpenCB: boolean = false;
  isJpNumberCB: boolean = false;
  noresultCB: any = "";
  booking_status: any = [
    { key: 2, value: "Booked" },
    { key: 4, value: "Failed" },
    { key: 1, value: "Pending" },
    { key: 7, value: "Canceled" }
  ];
  TransactionscreenId: any = "";
  Errmessage: any = "";
  headerDivName: string = "errMsgDiv";
  MilesYouHave: any = "";
  totalMiles: any = "";
  Rpm: any = 0.3;
  MilesRefunded: any = 0;
  CancellationMilesCB: any = 0;
  CancellationMilesInboundCB: any = 0;
  cancelResponse: any = {};
  newDate: any = new Date();
  myDate: any = new Date();
  totalItems: number = 1;
  typeOfRedemption: any = "A";
  typeOfRedem: any = "A";
  isEMT: boolean = false;
  IsErr: boolean = false;
  isUniqueFilter: boolean = false;
  initialPageCount: number = 1;
  
  constructor(
    private vernostService: VernostServiceService,
    private router: Router,
    private datePipe: DatePipe
  ) { }

  ngOnInit() {
    // this.myDate.setDate(this.myDate.getDate() - 1)
    this.isJpNumberCB = false;
    this.cancelbtnCB = true;
    this.isCancelOpenCB = false;
    this.uidCB = localStorage.getItem("uid");
    if (this.uidCB == "" || this.uidCB == undefined) {
      this.router.navigate(["/login"]);
    }

    for(let item of serverConfigInfo.affliatepartner.partners){
      this.cancelBooking_aff_partner.push({key: item, value: item});
    }
    
    this.search_details_CB = {
      jp_number: "",
      order_id: "",
      first_name: "",
      last_name: "",
      airlinepnr: "",
      status: "E",
      isMailSent: "",
      aff_partner: "E",
      tripdate_from: "",
      tripdate_to: "",
      bookingdate_from: "",
      bookingdate_to: "",
      Ticket_No: "",
      emt: "",
      supplier_id :""
    };
    
  }
  ngAfterContentInit() {
    this.search_details_CB.bookingdate_to = new Date();
    this.search_details_CB.bookingdate_from = new Date();
    this.final = this.search_details_CB.bookingdate_to.setDate(
      this.search_details_CB.bookingdate_to.getDate()
    );
    this.final = new Date(this.final);
    this.IsEmptyVal = true;
   // this.searchData();
  }
  searchForm() {
    this.segment_details1 = [];
    this.segment_details2 = [];
    this.selectedOutboundPaxArrayCB = [];
    this.selectedInboundPaxArrayCB = [];
    this.existingbooking = true;
    this.bookinglist = false;
    this.searchData();
    this.Errmessage = "";
    this.CancellationMilesInboundCB = 0;
    this.CancellationMilesCB = 0;
  }
  searchData() {
    this.noresultCB = "";
    this.loader = true;
    this.searchlist = false;
    this.cancelbtnCB = true;
    this.search_result_list = [];
    this.order_Id_list = [];
    this.search_detail_list = [];

    var TodateCB = this.search_details_CB.bookingdate_to;
    if (TodateCB != "") {
      TodateCB.setDate(TodateCB.getDate());
    }
    this.search_details_CB.bookingdate_from = this.datePipe.transform(
      this.search_details_CB.bookingdate_from,
      "yyyy-MM-dd"
    );
    TodateCB = this.datePipe.transform(TodateCB, "yyyy-MM-dd");
    var boofrom = this.search_details_CB.bookingdate_from;
    var bookto = TodateCB;
    var AirLine_PnrCB = this.search_details_CB.airlinepnr;
    var jp_numberCB = "";
    if (this.typeOfRedemption == "A") {
      jp_numberCB = this.search_details_CB.jp_number;
    }
    if (this.typeOfRedemption == "R") {
      jp_numberCB = "00" + this.search_details_CB.jp_number;
    }
    if(this.search_details_CB.order_id.startsWith("JPUB")){
    var BOOKING_REF_NO = (this.search_details_CB.order_id.toString().length > 12 ? this.search_details_CB.order_id.slice(4, this.search_details_CB.order_id.length) : this.search_details_CB.order_id);
    }else{
      BOOKING_REF_NO=this.search_details_CB.order_id;
    }
    var data = {
      jp_number: jp_numberCB,
      order_id: BOOKING_REF_NO,
      first_name: this.search_details_CB.first_name,
      last_name: this.search_details_CB.last_name,
      airlinepnr: AirLine_PnrCB.toUpperCase(),
      fromdate: this.search_details_CB.tripdate_from,
      status: this.search_details_CB.status,
      todate: this.search_details_CB.tripdate_to,
      booking_fromdate: boofrom,
      booking_todate: bookto,
      Ticket_No: this.search_details_CB.Ticket_No,
      pagination: this.p,
      isMailSent: this.search_details_CB.isMailSent,
      typeOfRedemption: this.typeOfRedemption,
      emtId: this.search_details_CB.emt,
      supplierId :this.search_details_CB.supplier_id ,
      affiliate_partner: this.search_details_CB.aff_partner,
      isUniqueFilter: this.isUniqueFilter,
      initialPageCount: this.initialPageCount
    };
    //  console.log("Data::::",data);
    this.vernostService.getCancelBooking(data).subscribe(response => {
      this.typeOfRedem = this.typeOfRedemption;
      var Data = response;
      var count = Data[0].count;
      this.initialPageCount = Data[0].count;
      this.totalItems = count;
      this.search_result_list = Data[0].result;
      // console.log("this.search_result_list", this.search_result_list);
      var SegmentList = [];
      for (var i = 0; i < this.search_result_list.length; i++) {
        // if (this.order_Id_list.indexOf(this.search_result_list[i].Booking_Ref) == -1 && ) {
        //   SegmentList.push(this.search_result_list[i]);
        // }
        if (
          this.order_Id_list.indexOf(this.search_result_list[i].Booking_Ref) ==
          -1) {
          this.order_Id_list.push(this.search_result_list[i].Booking_Ref);
          this.search_detail_list.push(this.search_result_list[i]);
        }

      }

      if (
        this.search_detail_list.length == 0 ||
        this.search_detail_list == undefined ||
        this.search_detail_list == ""
      ) {
        // alert("here");git 
        this.noresultCB = "Result Not Found";
        this.loader = false;
        //document.getElementById("noresulrErr").innerHTML = "Result Not Found";
      } else {
        this.loader = false;
      }
    });
  }
  IsEmptyVal: boolean = false;
  isEmptyCheck() {
    if (
      this.search_details_CB.jp_number == "" &&
      this.search_details_CB.airlinepnr == "" &&
      this.search_details_CB.order_id == "" &&
      this.search_details_CB.Ticket_No == "" &&
      this.search_details_CB.first_name == "" &&
      this.search_details_CB.last_name == "" &&
      this.search_details_CB.status == "E" &&
      this.search_details_CB.emt == "" &&
      this.search_details_CB.supplier_id == "" &&
      ((this.search_details_CB.bookingdate_from == "" || this.search_details_CB.bookingdate_from == null) ||
        (this.search_details_CB.bookingdate_to == "" || this.search_details_CB.bookingdate_to == null))
    ) {
      this.IsEmptyVal = false;
    } else {
      this.IsEmptyVal = true;
    }
    if(((this.search_details_CB.bookingdate_from != "" && this.search_details_CB.bookingdate_from != null) &&
    this.search_details_CB.bookingdate_to == "" || this.search_details_CB.bookingdate_to == null) || ((this.search_details_CB.bookingdate_from == "" || this.search_details_CB.bookingdate_from == null) &&
    this.search_details_CB.bookingdate_to != "" && this.search_details_CB.bookingdate_to != null) ){
      this.IsEmptyVal = false;
    }
    if(this.search_details_CB.airlinepnr !== "" || this.search_details_CB.order_id !== "" || this.search_details_CB.Ticket_No !== "" || this.search_details_CB.jp_number !== "" || this.search_details_CB.first_name !=="" || this.search_details_CB.last_name !=="") {
      this.isUniqueFilter = true;
      this.search_details_CB.ancillary_type = "";
      this.search_details_CB.status = "E";
      this.p = 1;
      // this.search_details_CB.ancillary_status = "";
    } else {
      this.isUniqueFilter = false;
    }
  }
  selectTypeOfRedemption(type) {
    console.log("TYPE:::::::::::::::", type);
    this.typeOfRedemption = type;
    if (type == 'A') {
      this.isAccrual = true;
    } else {
      this.search_details_CB.aff_partner = 'E';
      this.isAccrual = false;
    }
    // this.searchForm();
  }

  pageCount(count) {
    this.p = count;
    this.searchData();
    console.log("P:::", this.p);
  }
  book_details(param) {
    // this.router.navigate(['/navigation/ordermanage']);
    var reqCB = { booking_ref: param };
    this.router.navigate(["/navigation/CancellationManagement"], { queryParams: reqCB });
  }
  orderValidation1() {
    this.disablebtnCB = false;
    var JPNoOrderCB = this.search_details_CB.order_id;
    if (JPNoOrderCB.length > 0) {
      if (JPNoOrderCB.length < 14) {
        document.getElementById("orErr").innerHTML =
          "Please enter 18 digit Booking Reference No ";
        document.getElementById("orErr").style.color = "red";
        this.isOrd = true;
        this.IsErr = true;
      } else {
        document.getElementById("orErr").innerHTML = "";
        this.isOrd = false;
        this.IsErr = false;
      }
    }
  }
  jpNumberValidation() {
    this.disablebtnCB = false;
    var regex = /^[A-Za-z0-9_]+$/;

    var JPNoCBValid = this.search_details_CB.jp_number;
    if (JPNoCBValid != "" && regex.test(JPNoCBValid) == false) {
      document.getElementById("JpErr").innerHTML =
        "Only Alphabets and Numbers allowed";
      document.getElementById("JpErr").style.color = "red";
      this.isJpNumberCB = true;
      this.IsErr = true;
    } else {
      document.getElementById("JpErr").innerHTML = "";
      this.isJpNumberCB = false;
      this.IsErr = false;
    }
  }

  fnameValidation() {
    this.disablebtnCB = false;
    var regex = /^[A-Za-z]+$/;

    var JPNoCBFname = this.search_details_CB.first_name;
    if (JPNoCBFname != "" && regex.test(JPNoCBFname) == false) {
      document.getElementById("fnErr").innerHTML = "Only Alphabets allowed";
      document.getElementById("fnErr").style.color = "red";
      this.isFname = true;
      this.IsErr = true;
    } else {
      document.getElementById("fnErr").innerHTML = "";
      this.isFname = false;
      this.IsErr = false;
    }
  }
  lnameValidation() {
    this.disablebtnCB = false;
    var regex = /^[A-Za-z]+$/;

    var JPNoCBLname = this.search_details_CB.last_name;

    if (JPNoCBLname != "" && regex.test(JPNoCBLname) == false) {
      document.getElementById("lnErr").innerHTML = "Only Alphabets allowed";
      document.getElementById("lnErr").style.color = "red";
      this.isLname = true;
      this.IsErr = true;
    } else {
      document.getElementById("lnErr").innerHTML = "";
      this.isLname = false;
      this.IsErr = false;
    }
  }
  orderValidation() {
    this.disablebtnCB = false;
    var regex = /^[A-Za-z0-9_]+$/;

    var JPNoCBOrderValid = this.search_details_CB.order_id;
    if (JPNoCBOrderValid != "" && regex.test(JPNoCBOrderValid) == false) {
      document.getElementById("orErr").innerHTML =
        "Only Alphabets and Numbers allowed";
      document.getElementById("orErr").style.color = "red";
      this.isOrd = true;
      this.IsErr = true;
    } else {
      document.getElementById("orErr").innerHTML = "";
      this.isOrd = false;
      this.IsErr = false;
    }
  }

  pnrValidation() {
    this.disablebtnCB = false;

    var regex = /^[A-Za-z0-9_]+$/;
    this.search_details_CB.airlinepnr = this.search_details_CB.airlinepnr.toUpperCase();
    var JPNoPNRCB = this.search_details_CB.airlinepnr;

    if (JPNoPNRCB != "" && regex.test(JPNoPNRCB) == false) {
      document.getElementById("pnrNO").innerHTML =
        "Only Alphabets and Numbers allowed";
      document.getElementById("pnrNO").style.color = "red";
      this.isPnr = true;
      this.IsErr = true;
    } else {
      document.getElementById("pnrNO").innerHTML = "";
      this.isPnr = false;
      this.IsErr = false;
    }
  }
  EMTidValidation(){
    this.disablebtnCB = false;

    var regex = /^[A-Za-z0-9_]+$/;
    this.search_details_CB.emt = this.search_details_CB.emt.toUpperCase();
    var EmtIdCB = this.search_details_CB.emt;

    if (EmtIdCB != "" && regex.test(EmtIdCB) == false) {
      document.getElementById("EMT_id_err").innerHTML =
        "Only Alphabets and Numbers allowed";
      document.getElementById("EMT_id_err").style.color = "red";
      this.isEMT = true;
    } else {
     if(EmtIdCB != "" &&  !EmtIdCB.startsWith('EMT')){
      document.getElementById("EMT_id_err").innerHTML = "Supplier ID start with EMT";
      document.getElementById("EMT_id_err").style.color = "red";
      this.isEMT = true;
      this.IsErr = true;
    }else{
      document.getElementById("EMT_id_err").innerHTML = "";
      this.isEMT = false;
      this.IsErr = false;
    }
    }
    
  }
  supplierIdValidation(){
    
    this.disablebtnCB = false;
    var regex = /^[A-Za-z0-9_]+$/;
    this.search_details_CB.supplier_id = this.search_details_CB.supplier_id.toUpperCase();
    var supplierIdCB = this.search_details_CB.supplier_id;

    if (supplierIdCB != "" && regex.test(supplierIdCB) == false) {
      document.getElementById("supplier_id_err").innerHTML =
        "Only Alphabets and Numbers allowed";
      document.getElementById("supplier_id_err").style.color = "red";
      this.IsErr = true;
    } else {
      if(supplierIdCB != "" && supplierIdCB.startsWith('EMT')){
        document.getElementById("supplier_id_err").innerHTML =
        "Enter Valid Supplier ID";
        document.getElementById("supplier_id_err").style.color = "red";
        this.IsErr = true;
      } else {
        document.getElementById("supplier_id_err").innerHTML = "";
        this.IsErr = false;
      }
    }
  }
  toggleDisable1() {
    this.bookingdate = true;

    if (
      this.search_details_CB.tripdate_from.length != "" ||
      this.search_details_CB.tripdate_to.length != ""
    ) {
      this.bookingdate = true;
    } else {
      this.bookingdate = false;
    }

    if (this.search_details_CB.tripdate_from.length != "") {
      this.tomorrow = this.search_details_CB.tripdate_from;
      this.tomorrow.setDate(this.tomorrow.getDate() + 1);
    }
  }

  toggleDisable2() {
    this.journeydate = true;
    this.search_details_CB.bookingdate_to = "";
    // if (
    //   this.search_details_CB.bookingdate_from.length != "" ||
    //   this.search_details_CB.bookingdate_to.length != ""
    // ) {
    //   this.journeydate = true;
    // } else {
    //   this.journeydate = false;
    // }

    // if (this.search_details_CB.bookingdate_from.length != "") {
    //   this.tomorrow1 = this.search_details_CB.bookingdate_from;
    //   this.tomorrow1.setDate(this.tomorrow1.getDate() + 1);
    // }
  }

  checkempty() {
    if (
      this.search_details_CB.jp_number.length == 0 &&
      this.search_details_CB.last_name.length == 0 &&
      this.search_details_CB.first_name.length == 0 &&
      this.search_details_CB.airlinepnr.length == 0 &&
      this.search_details_CB.order_id.length == 0 &&
      this.search_details_CB.emt.length == 0 &&
      this.search_details_CB.supplier_id.length == 0 &&
      this.search_details_CB.status == "E"
    ) {
      this.disablebtnCB = true;
    }

    if (
      (this.search_details_CB.jp_number.length != 0 ||
        this.search_details_CB.last_name.length != 0 ||
        this.search_details_CB.first_name.length != 0 ||
        this.search_details_CB.airlinepnr.length != 0 ||
        this.search_details_CB.order_id.length != 0 ||
        this.search_details_CB.emt.length == 0 ||
      this.search_details_CB.supplier_id.length == 0 ||
        this.search_details_CB.status != "E") &&
      (this.search_details_CB.bookingdate_from != "" &&
        this.search_details_CB.bookingdate_to != "")
    ) {
      this.disablebtnCB = false;
    }

    if (
      (this.search_details_CB.jp_number.length != 0 ||
        this.search_details_CB.last_name.length != 0 ||
        this.search_details_CB.first_name.length != 0 ||
        this.search_details_CB.airlinepnr.length != 0 ||
        this.search_details_CB.order_id.length != 0 ||
        this.search_details_CB.emt.length == 0 ||
      this.search_details_CB.supplier_id.length == 0 ||
        this.search_details_CB.status != "E") &&
      (this.search_details_CB.bookingdate_from == "" &&
        this.search_details_CB.bookingdate_to == "")
    ) {
      this.disablebtnCB = false;
    }

    if (
      this.search_details_CB.bookingdate_from == "" &&
      this.search_details_CB.bookingdate_to != ""
    ) {
      this.disablebtnCB = true;
    }

    if (
      this.search_details_CB.bookingdate_from != "" &&
      this.search_details_CB.bookingdate_to == ""
    ) {
      this.disablebtnCB = true;
    }
  }

  checkStatus1() {
    this.mydate = this.search_details_CB.bookingdate_from;

    //    var endDate=startDate.setDate(startDate.getDate() + 1);

    // this.tomorrow = this.search_details_CB.tripdate_from;
    //   // this.tomorrow = this.tomorrow.getDate() + 1;
    this.checkempty();
    this.showsingle1 = true;
    this.showMultiple1 = true;

    if (
      this.search_details_CB.bookingdate_from != "" &&
      this.search_details_CB.bookingdate_to != ""
    ) {
      this.downd = false;
      //  this.disablebtnCB = true;
      // this.checkempty();
    } else {
      this.downd = true;
    }
  }

  reset() {
    this.input.value = "";
    this.search_details_CB.tripdate_from = "";
    this.tomorrow = "";
  }

  reset2() {
    this.input2.value = "";
    this.search_details_CB.tripdate_to = "";
  }

  reset3() {
    this.input3.value = "";

    this.search_details_CB.bookingdate_from = "";
    this.tomorrow1 = "";
    this.isEmptyCheck();
  }

  reset4() {
    this.input4.value = "";
    this.search_details_CB.bookingdate_to = "";
    this.isEmptyCheck();
  }

  checkDate() {
    this.invaliddateCB = false;
    if (
      this.search_details_CB.bookingdate_to != " " &&
      this.search_details_CB.bookingdate_to != "" &&
      this.search_details_CB.bookingdate_to != null
    ) {
      if (
        this.search_details_CB.bookingdate_from >=
        this.search_details_CB.bookingdate_to
      ) {
        this.invaliddateCB = true;
      }
    }
  }

  incresedate() {
    var tomorrowIncreaseDate = (document.getElementById("did") as HTMLInputElement).value;
    var tam = new Date(tomorrowIncreaseDate);
    // console.log(tomorrow,"tomorrow");
    this.final = tam.setDate(tam.getDate());
    this.final = new Date(this.final);

    // alert(this.final);
    //alert(this.search_details_CB.bookingdate_from);
  }
  keypresshandler(event) {
    var charCode = event.keyCode;
    //Non-numeric character range
    if (charCode > 31 && (charCode < 48 || charCode > 57)) return false;
  }

  DownloadData() {
    this.noresultCB = "";
    this.loader = true;
    this.searchlist = false;
    this.cancelbtnCB = true;
    // this.search_result_list = [];
    // this.order_Id_list = [];
    // this.search_detail_list = [];

    var Todate = this.search_details_CB.bookingdate_to;
    if (Todate != "") {
      Todate.setDate(Todate.getDate());
    }
    this.search_details_CB.bookingdate_from = this.datePipe.transform(
      this.search_details_CB.bookingdate_from,
      "yyyy-MM-dd"
    );
    Todate = this.datePipe.transform(Todate, "yyyy-MM-dd");
    var boofrom = this.search_details_CB.bookingdate_from;
    var bookto = Todate;
    var AirLine_Pnr = this.search_details_CB.airlinepnr;
    var jp_number = "";
    var BOOKING_REF_NO;
    if (this.typeOfRedemption == "A") {
      jp_number = this.search_details_CB.jp_number;
    }
    if (this.typeOfRedemption == "R") {
      jp_number = "00" + this.search_details_CB.jp_number;
    }
    if (this.search_details_CB.order_id.startsWith("JPUB")) {
      BOOKING_REF_NO = (this.search_details_CB.order_id.toString().length > 12 ? this.search_details_CB.order_id.slice(4, this.search_details_CB.order_id.length) : this.search_details_CB.order_id);
    } else {
      BOOKING_REF_NO = this.search_details_CB.order_id;
    }
    var data = {
      jp_number: jp_number,
      order_id: BOOKING_REF_NO,
      first_name: this.search_details_CB.first_name,
      last_name: this.search_details_CB.last_name,
      airlinepnr: AirLine_Pnr,
      fromdate: this.search_details_CB.tripdate_from,
      status: this.search_details_CB.status,
      todate: this.search_details_CB.tripdate_to,
      booking_fromdate: boofrom,
      booking_todate: bookto,
      Ticket_No: this.search_details_CB.Ticket_No,
      pagination: this.p,
      isMailSent: this.search_details_CB.isMailSent,
      typeOfRedemption: this.typeOfRedemption,
      emtId: this.search_details_CB.emt,
      supplierId : this.search_details_CB.supplier_id,
      affiliate_partner: this.search_details_CB.aff_partner
    };
    //  console.log("Data::::",data);
    this.vernostService.downloadCancelBooking(data).subscribe(
      result => {
        // console.log("result",result.size);
        this.noresultCB = "";
        if (result.size != 0) {
          saveAs(result, "CancelBooking.csv");
        } else {
          this.noresultCB = "Result Not Found";
        }
        this.loader = false;
      },
      err => { }
    );
  }
}
